'use strict';

var Steps = require('./Steps');
Steps.Step = require('./Step');

module.exports = Steps;


/*****************
 ** WEBPACK FOOTER
 ** ./~/._rc-steps@2.4.3@rc-steps/lib/index.js
 ** module id = 618
 ** module chunks = 0 1
 **/